export const nameToSlug = (name) => {
  const replaceSymbols = new RegExp(/[^a-zA-Z0-9]/g);
  const trimDuplicate = new RegExp(/-+/g);
  const trimStartEnd = new RegExp(/(^-+)|(-+$)/g);

  const slug = name
    .toLowerCase()
    .replace(replaceSymbols, "-")
    .replace(trimDuplicate, "-")
    .replace(trimStartEnd, "");

  return slug;
};

export const parseStringifiedObject = (object) => {
  try {
    return JSON.parse(object);
  } catch (error) {
    return object;
  }
};
export const makeRedemptionInstructions = (redemptionInstructions) => {
  if (!redemptionInstructions) return null;

  const redemptionSplit = redemptionInstructions.split(/\d\. /);
  const isList = redemptionSplit.length > 2;
  return isList ? (
    <ol>
      {redemptionSplit.filter(Boolean).map((instruction) => (
        <li key={instruction}>{instruction}</li>
      ))}
    </ol>
  ) : (
    redemptionInstructions
  );
};

export const capitalizeFirstLetter = (textString) => {
  return textString[0].toUpperCase() + textString.slice(1);
};

export const replaceRouteParams = (path, value) => {
  return path.replace(/:\w+/, value);
};

export const formatPhoneNumber = (phone) => {
  return `+1${phone.replace(/\D/g, "")}`;
};
